function initVideoContainers(selector = '.video-container') {
  const getVideoSrc = (video) => {
    const src = (video.getAttribute('src') || '').trim();
    if (src) return src;
    const source = video.querySelector('source[src]');
    return source ? source.getAttribute('src').trim() : '';
  };

  const getIframeSrc = (iframe) => {
    const src = (iframe.dataset.src || iframe.getAttribute('src') || '').trim();
    if (src) return src;
    const id = (iframe.dataset.id || '').trim();
    return id ? `https://www.youtube.com/embed/${id}` : '';
  };

  const withAutoplay = (url) => {
    const u = new URL(url, location.href);
    u.searchParams.set('autoplay', '1');
    return u.toString();
  };

  document.querySelectorAll(selector).forEach((container) => {
    const cover = container.querySelector('.cover');
    const playButton = container.querySelector('.play-button');
    const video = container.querySelector('video');
    const iframe = container.querySelector('iframe');

    if (!cover) return;

    const iframeSrc = iframe ? getIframeSrc(iframe) : '';
    const videoSrc = video ? getVideoSrc(video) : '';

    if (!iframeSrc && !videoSrc) {
      if (playButton) playButton.classList.add('hide');
      return;
    }

    if (iframe) {
      iframe.removeAttribute('src');
      iframe.dataset.src = iframeSrc;
    }

    cover.addEventListener('click', () => {
      cover.classList.add('hide');

      if (iframe) {
        iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen');
        iframe.src = withAutoplay(iframeSrc);
      } else if (video) {
        video.controls = true;
        video.play().catch((err) => console.warn('Nie udało się odtworzyć video:', err));
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initVideoContainers());
